export const GRAPH_TAB = 1;
export const MAX_CHART_WEEKS = 5;
